import { ICallToActionLink } from '@/ui';
import { ICallToActionSectionEntry } from '../../../../contentful/types/ICallToActionSectionEntry';
import CallToAction from '../../../../components/common/call-to-action/CallToAction';
import { useCommonData } from '../../../../common-data/useCommonData';
import { getLinkItemsForEntries } from '../../domain/use-cases/getLinkItemsForEntries';
import { Section } from './Section';

export interface ICallToActionsSectionProps {
	section: ICallToActionSectionEntry;
}

export function CallToActionSection({ section }: ICallToActionsSectionProps) {
	const { pathToPageIdMap } = useCommonData();
	const links = getLinkItemsForEntries<ICallToActionLink>(
		section.fields.links,
		pathToPageIdMap,
	);

	return (
		<Section>
			<CallToAction
				title={section.fields.title}
				body={section.fields.description}
				links={links}
				ctaType={section.fields.theme}
			/>
		</Section>
	);
}
